var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fw-simple-card-wrapper",class:{
         "fw-simple-card-wrapper--disabled": _vm.isDisabled,
         "fw-simple-card-wrapper--active": _vm.isActive,
     },style:(_vm.wrapperStyles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }